export async function getLiveStreamsSearch() {
  const gapi = (window as any).gapi;

  const response = await gapi.client.youtube.search.list({
    part: "snippet",
    eventType: "live",
    maxResults: 50,
    order: "viewCount",
    safeSearch: "moderate",
    type: "video",
  });

  return response;
}
